import { jsx } from "@builder.io/qwik/jsx-runtime";
import { component$, useContext, useComputed$, Slot } from "@builder.io/qwik";
import SelectContextId from "./select-context.qwik.mjs";
const HSelectDisplayValue = component$((props) => {
  const { placeholder, ...rest } = props;
  const context = useContext(SelectContextId);
  const valueId = `${context.localId}-value`;
  const displayStrSig = useComputed$(() => {
    if (context.multiple) {
      return /* @__PURE__ */ jsx(Slot, {});
    }
    if (context.selectedIndexSetSig.value.size === 0) {
      return placeholder;
    } else {
      return context.multiple ? context.currDisplayValueSig.value : context.currDisplayValueSig.value?.[0] ?? placeholder;
    }
  });
  return /* @__PURE__ */ jsx("span", {
    id: valueId,
    "data-open": context.isListboxOpenSig.value ? "" : void 0,
    "data-closed": !context.isListboxOpenSig.value ? "" : void 0,
    "data-value": true,
    ...rest,
    children: displayStrSig.value
  });
});
export {
  HSelectDisplayValue
};
